import React, { useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import UsersCreateCard from '../components/users/UsersCreateCard'
import apiLoginService from '../services/apiLoginService'
import '../styles/FormView.css'

function UsersAddView() {
  const navigate = useNavigate()
  const role = (sessionStorage.getItem('role') || '').toUpperCase()
  const isWholesaler = role === 'WHOLESALER'
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    // Un mayorista solo puede dar de alta distribuidores.
    role: isWholesaler ? 'DISTRIBUTOR' : 'WHOLESALER',
    wholesaler: '',
  })
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.username.trim()) {
      newErrors.username = 'El usuario es requerido'
    }

    if (!formData.password.trim()) {
      newErrors.password = 'La contraseña es requerida'
    }

    if (!formData.role) {
      newErrors.role = 'El rol es requerido'
    }

    return newErrors
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSubmitted(true)
    setErrorMessage('')
    setSuccessMessage('')

    const newErrors = validateForm()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    setIsSaving(true)
    try {
      await apiLoginService.register({
        username: formData.username,
        password: formData.password,
        role: formData.role,
        wholesaler: formData.wholesaler || null,
      })
      setSuccessMessage('Usuario creado correctamente.')
      setTimeout(() => navigate('/users'), 600)
    } catch (error) {
      const message =
        error?.body?.message || 'No se pudo registrar el usuario.'
      setErrorMessage(message)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>Usuarios</h1>
          </div>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <UsersCreateCard
                formData={formData}
                errors={errors}
                submitted={submitted}
                isSaving={isSaving}
                errorMessage={errorMessage}
                successMessage={successMessage}
                onInputChange={handleInputChange}
                onSubmit={handleSubmit}
                isWholesaler={isWholesaler}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default UsersAddView
